var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded && _vm.start)?_c(_vm.way,{tag:"component",attrs:{"token":_vm.token,"page_type":_vm.page_type,"from-registration":_vm.fromRegistration}}):_c('router-view',{attrs:{"token":_vm.token}})
}
var staticRenderFns = []

export { render, staticRenderFns }